"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var react_apollo_1 = require("react-apollo");
var graphql_tag_1 = require("graphql-tag");
var rql_1 = require("../../../schemas/rql");
var modal_dialog_1 = require("@reverbdotcom/commons/dist/components/modal_dialog");
var address_row_1 = require("../../addresses/address_row");
var address_form_1 = require("../../addresses/address_form");
var parse_graphql_errors_1 = require("@reverbdotcom/commons/dist/parse_graphql_errors");
function deleteEuAddress(props, handleDeleteSuccess, uuid) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var updateData;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updateData = {
                        addressType: rql_1.core_apimessages_MyAddressType.EU_ODR_PLATFORM,
                        uuid: uuid,
                    };
                    return [4 /*yield*/, props.deleteEuAddressMutation({
                            variables: { input: updateData },
                            refetchQueries: function (_mutationResult) {
                                return [{
                                        query: euOdrAddressGQL,
                                        variables: {
                                            slug: props.shopSlug,
                                        },
                                    }];
                            },
                            awaitRefetchQueries: true,
                        })];
                case 1:
                    _a.sent();
                    handleDeleteSuccess();
                    return [2 /*return*/];
            }
        });
    });
}
function upsertEuAddress(props, addressFormData, handleSuccess, handleErrors) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var updateData, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updateData = {
                        addressType: rql_1.core_apimessages_MyAddressType.EU_ODR_PLATFORM,
                        address: addressFormData,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, props.upsertEuAddressMutation({
                            variables: { input: updateData },
                            refetchQueries: function (_mutationResult) {
                                return [{
                                        query: euOdrAddressGQL,
                                        variables: {
                                            slug: props.shopSlug,
                                        },
                                    }];
                            },
                            awaitRefetchQueries: true,
                        })];
                case 2:
                    _a.sent();
                    handleSuccess();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    handleErrors(e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function EuOdrDetailsDashboardContainer(props) {
    var _a = props.data, loading = _a.loading, shop = _a.shop, countries = _a.countries;
    var _b = React.useState(false), modalOpen = _b[0], setModalOpen = _b[1];
    var _c = React.useState(false), isSaving = _c[0], setIsSaving = _c[1];
    var _d = React.useState({}), addressFormData = _d[0], setAddressFormData = _d[1];
    var _e = React.useState([]), errors = _e[0], setErrors = _e[1];
    var addressForm = null;
    React.useEffect(function () {
        if (!shop || !shop.euOdrAddress) {
            return;
        }
        var euOdrAddress = shop.euOdrAddress;
        setAddressFormData({
            name: euOdrAddress.name,
            streetAddress: euOdrAddress.streetAddress,
            postalCode: euOdrAddress.postalCode,
            phone: euOdrAddress.phone,
            region: euOdrAddress.region,
            locality: euOdrAddress.locality,
            countryCode: euOdrAddress.countryCode,
            email: euOdrAddress.email,
        });
    }, [shop]);
    function toggleOpen() {
        setModalOpen(!modalOpen);
    }
    function handleSuccess() {
        toggleOpen();
        setIsSaving(false);
        setErrors([]);
    }
    function handleError(e) {
        setErrors(parse_graphql_errors_1.parseGraphqlErrors(e));
        setIsSaving(false);
    }
    function handleSubmit() {
        if (isSaving) {
            return;
        }
        var form = addressForm;
        if (form && form.reportValidity && !form.reportValidity()) {
            return;
        }
        setIsSaving(true);
        upsertEuAddress(props, addressFormData, handleSuccess, handleError);
    }
    function handleDelete() {
        var _a;
        if (isSaving) {
            return;
        }
        setIsSaving(true);
        deleteEuAddress(props, handleSuccess, (_a = shop.euOdrAddress) === null || _a === void 0 ? void 0 : _a.uuid);
    }
    function deleteCallback() {
        var _a;
        if ((_a = shop) === null || _a === void 0 ? void 0 : _a.euOdrAddress) {
            return handleDelete;
        }
        return null;
    }
    function handleUpdateField(addressAttributes) {
        setAddressFormData(tslib_1.__assign(tslib_1.__assign({}, addressFormData), addressAttributes));
    }
    function handleAddNewAddress(e) {
        e.preventDefault();
        toggleOpen();
    }
    function setAddressFormRef(ref) {
        addressForm = ref;
    }
    if (loading || !shop) {
        return null;
    }
    if (!shop.euOdrAddress && !modalOpen) {
        return (React.createElement("button", { "data-add-address-button": true, onClick: function (e) { return handleAddNewAddress(e); }, className: "button", type: "button" }, I18n.t('discovery.addressBook.addNewEuOdrAddressBtn')));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("ul", { className: "actionable-rows" }, shop.euOdrAddress && React.createElement(address_row_1.default, { address: shop.euOdrAddress, onEdit: toggleOpen, addressType: rql_1.core_apimessages_MyAddressType.EU_ODR_PLATFORM })),
        React.createElement(modal_dialog_1.default, { headerTitle: I18n.t('discovery.addressBook.form.title.euOdrSellerDetails'), isOpen: modalOpen, onRequestClose: toggleOpen, onDelete: deleteCallback(), onSubmit: handleSubmit, isSaving: isSaving, backButtonText: I18n.t('discovery.checkout.addressBook.cancel'), containsFormElement: true },
            React.createElement(address_form_1.default, { addressFormData: addressFormData, countries: countries.countries, addressType: rql_1.core_apimessages_MyAddressType.EU_ODR_PLATFORM, onUpdateField: handleUpdateField, addressIsCurrentPrimary: false, errors: errors, formRef: setAddressFormRef }))));
}
exports.EuOdrDetailsDashboardContainer = EuOdrDetailsDashboardContainer;
var upsertEuAddressMutation = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      mutation Core_Dashboard_UpdateShopEuAddress($input: Input_core_apimessages_UpdateAddressRequest) {\n        updateMyAddress(input: $input) {\n          address {\n            uuid\n          }\n        }\n      }\n    "], ["\n      mutation Core_Dashboard_UpdateShopEuAddress($input: Input_core_apimessages_UpdateAddressRequest) {\n        updateMyAddress(input: $input) {\n          address {\n            uuid\n          }\n        }\n      }\n    "]))), {
    name: 'upsertEuAddressMutation',
});
var deleteEuAddressMutation = react_apollo_1.graphql(graphql_tag_1.default(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      mutation DeleteEuAddress($input: Input_core_apimessages_AddressDeleteRequest) {\n        deleteMyAddress(input: $input) {\n          uuid\n        }\n      }\n    "], ["\n      mutation DeleteEuAddress($input: Input_core_apimessages_AddressDeleteRequest) {\n        deleteMyAddress(input: $input) {\n          uuid\n        }\n      }\n    "]))), {
    name: 'deleteEuAddressMutation',
});
var euOdrAddressGQL = graphql_tag_1.default(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\nquery Core_Dashboard_EuOdrAddress(\n  $slug: String\n) {\n  countries {\n    countries {\n      name\n      countryCode\n      subregions {\n        name\n        code\n      }\n    }\n  }\n  shop(input: {slug: $slug}) {\n    euOdrAddress {\n      name\n      streetAddress\n      displayLocation\n      postalCode\n      email\n      phone\n      countryCode\n      region\n      locality\n      uuid\n    }\n  }\n}\n"], ["\nquery Core_Dashboard_EuOdrAddress(\n  $slug: String\n) {\n  countries {\n    countries {\n      name\n      countryCode\n      subregions {\n        name\n        code\n      }\n    }\n  }\n  shop(input: {slug: $slug}) {\n    euOdrAddress {\n      name\n      streetAddress\n      displayLocation\n      postalCode\n      email\n      phone\n      countryCode\n      region\n      locality\n      uuid\n    }\n  }\n}\n"])));
var euOdrAddressQuery = react_apollo_1.graphql(euOdrAddressGQL, {
    options: function (ownProps) {
        return {
            errorPolicy: 'all',
            variables: {
                slug: ownProps.shopSlug,
            },
        };
    },
});
exports.default = react_apollo_1.compose(upsertEuAddressMutation, deleteEuAddressMutation, euOdrAddressQuery)(EuOdrDetailsDashboardContainer);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=eu_odr_details_dashboard_container.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/dashboard/eu_odr_details/eu_odr_details_dashboard_container.js
// module id = ihjQ
// module chunks = 20 21